/** Refactor routing ok  */
import { RouteName } from "../RouteNames";

export const alertingRoutes = {
  path: "alerting",
  name: RouteName.NotificationRoot,
  component: () => import("@follaw-fr/views/top_menu_views/AlertingView.vue"),

  redirect: { name: RouteName.NotificationDigest }, // Redirect unmatched routes to the default

  children: [
    {
      path: "digests",
      name: RouteName.NotificationDigest,
      component: () =>
        import("@follaw-fr/views/top_menu_views/alerting/DigestsTemplate.vue"),
    },
    {
      path: "alerts",
      name: RouteName.NotificationAlerts,
      component: () =>
        import("@follaw-fr/views/top_menu_views/alerting/AlertsTemplate.vue"),
    },
  ],
};
